import React from 'react';
import { DeleteOutlined, PlusOutlined, TagOutlined } from '@ant-design/icons';

// Nouns used by TopBar to build tooltip text for selection-dependent buttons.
export const CLOUD_RESOURCE_NOUNS = { selectNoun: 'migration appliances', countNoun: 'appliance' };

// TopBar config for the Migration Appliances page.
export const PRIMARY_BUTTONS_CONFIG = [
    {
        key: 'addCloudAccount',
        buttonText: 'Add Migration Appliance',
        icon: <PlusOutlined />,
    },
];

export const SECONDARY_BUTTONS_CONFIG = [
    {
        key: 'addTags',
        icon: <TagOutlined />,
        color: 'primary',
        variant: 'outlined',
        size: 'middle',
        actionLabel: 'add tags',
        actionConnector: 'to',
    },
    {
        key: 'delete',
        icon: <DeleteOutlined />,
        danger: true,
        size: 'middle',
        actionLabel: 'delete',
    },
];
